import { HttpStatusCode } from 'axios';
import { ERROR_KEYS } from '@repo/utils';

interface ServerErrorResponse {
  status?: number;
  data?: { message?: unknown } | null;
}

/**
 * Il database momentaneamente irraggiungibile: il backend risponde 503 con la
 * chiave `errors.db_unavailable`, che l'utente vede tradotta. È un disservizio
 * transitorio già registrato lato server, non un errore da segnalare a Sentry.
 */
export function isDbUnavailableResponse(
  response: ServerErrorResponse | undefined
): boolean {
  return (
    response?.status === HttpStatusCode.ServiceUnavailable &&
    response.data?.message === ERROR_KEYS.DB_UNAVAILABLE
  );
}

/** Le risposte 5xx da mandare a Sentry: tutte tranne il DB non disponibile. */
export function shouldReportServerError(
  response: ServerErrorResponse | undefined
): boolean {
  const status = response?.status;
  if (status === undefined || status < HttpStatusCode.InternalServerError) {
    return false;
  }
  return !isDbUnavailableResponse(response);
}
